import { render, staticRenderFns } from "./TeachinStep.vue?vue&type=template&id=32b631ee&scoped=true&"
import script from "./TeachinStep.vue?vue&type=script&lang=js&"
export * from "./TeachinStep.vue?vue&type=script&lang=js&"
import style0 from "./TeachinStep.vue?vue&type=style&index=0&id=32b631ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b631ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VRow})
